import React, { Component } from 'react'

export default class SearchArea extends Component {
  render() {
    return <div>Search area</div>
  }
}
